/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ResolutionEnumDto {
    HOURLY = 'Hourly',
    DAILY = 'Daily',
    MONTHLY = 'Monthly',
}